export const mutations = {
  setStudentRoster(state, StudentRoster) {
    state.StudentRoster = StudentRoster;
  },
  setAdultRoster(state, AdultRoster) {
    state.AdultRoster = AdultRoster;
  },
  setRosterClasses(state, RosterClasses) {
    state.RosterClasses = RosterClasses;
  },
  setAdultRosterClasses(state, AdultRosterClasses) {
    state.AdultRosterClasses = AdultRosterClasses;
  },
};
